
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 50 50","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M15.1 36c-.4 0-.8-.1-1.1-.4l-9.5-9.5c-.3-.3-.4-.7-.4-1.1 0-.4.2-.8.4-1.1l9.6-9.6c.6-.6 1.5-.6 2.1 0s.6 1.5 0 2.1L7.6 25l8.4 8.4c.6.6.6 1.5 0 2.1-.2.4-.5.5-.9.5zM34.6 36c-.4 0-.8-.1-1.1-.4-.6-.6-.6-1.5 0-2.1l8.6-8.6-8.4-8.4c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l9.4 9.4c.6.6.6 1.5 0 2.1l-9.6 9.6c-.2.4-.6.5-1 .5zM22.9 38.3h-.2c-.8-.1-1.4-.9-1.2-1.7L25.3 13c.1-.8.9-1.4 1.7-1.2.8.1 1.4.9 1.2 1.7L24.4 37c-.2.8-.8 1.3-1.5 1.3z"}})])
          )
        }
      }
    